import { describe_error } from '../utils/ErrorDescriber';

import React, { useState, useEffect } from 'react';
import { Form, Button, Container, Row, Col, Card, Alert } from 'react-bootstrap';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';

import Constants from '../Constants';
import { get_user_error_message } from '../utils/ErrorMessages';
import { useAuth } from '../AuthContext';
import { clear_stored_page_analysis } from '../components/SitePageAnalysis';

import '../App.css';

import wordmark from '../assets/menu-wordmark.jpg';

// The onboarding wizard, which opens on the user's first login.
const c_OnboardingPath = '/onboarding';

function LoginView() {
  // const [email, setEmail] = useState(Constants.TEST_SIGNUP_EMAIL);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  // Opened by the AuthContext's logout after a 401 (session_expired=1), as Lead Barbarian's login page is
  const [session_expired] = useState(function() {
    const query_params = new URLSearchParams(window.location.search);
    return query_params.get('session_expired') === '1';
  });
  const navigate = useNavigate();
  
  const { setToken } = useAuth();

  useEffect(() => {

    // const token = localStorage.getItem(Constants.TOKEN_NAME);
    // if(success) {
    // if(token && (token != 'null')) {
    //   navigate('/');
    // }
  }, [success, navigate]);

	// Where the user lands after logging in: the onboarding wizard on their first login, otherwise the home view.
	// A failed check lands on the home view, so login never stalls on it.
	const get_landing_path = async(token)=>{
		try {
			const response = await axios.get(Constants.SERVER_URL + '/api/onboarding_status', { headers: { Authorization: 'Bearer ' + token } });
			if(response.data && response.data.show_onboarding){
				return c_OnboardingPath;
			}
		}
		catch (error) {
			console.log('LoginView/get_landing_path - ERROR: ', describe_error(error));
		}

		return '/';
	};

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);

    if(!email || !password) {
      setError('All fields are required.');
      return;
    }

    try {
      const url = Constants.SERVER_URL + '/api/auth/login';
      const response = await axios.post(url, { email, password });

      const user_data = response.data;
      if(user_data && user_data.token) {

        // Every stored AEO Audited token is deleted before the new one is stored
        localStorage.setItem(Constants.TOKEN_NAME, user_data.token);
        localStorage.setItem(Constants.USER_EMAIL, email);
        localStorage.setItem(Constants.USER_ID, user_data.user_id);

        // TEMP HACK: the page analysis view opens empty after logging in (see clear_stored_page_analysis).
        clear_stored_page_analysis();

        // setToken(response.data.token);
        // localStorage.setItem(Constants.TOKEN_NAME, response.data.token);
        setSuccess(true);
        // navigate('/');
		const landing_path = await get_landing_path(user_data.token);
        setTimeout(()=>{ navigate(landing_path);  window.location.href=landing_path;}, 100);
      } else {
        setError('Invalid email or password.');
      }
    } catch (error) {
		const message = get_user_error_message(error, 'Login failed. Please try again.');
		setError(message);
		if(message == 'User not active'){
			setTimeout(()=>{ navigate('/plans'); }, 1500);
		}
    }
  };

  const render_form_input = (controlId, label, type, placeholder, value, setter) => {
    return(
      <Form.Group className="mb-3" controlId={controlId}>
        <Form.Label>{label}</Form.Label>
        <Form.Control
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={(e) => setter(e.target.value)}
          required
        />
      </Form.Group>
    );
  };

  return (
    <Container fluid className='auth-container'>
      <Row className='auth-row'>
        <Col lg={4} md={6} sm={10} xs={11}>
          <Card className='auth-card'>
            <Card.Body className='auth-card-body'>
              

              {session_expired && !error && !success && <Alert variant="warning">Your session expired. Please log in again.</Alert>}
              {error && <Alert variant="danger">{error}</Alert>}
              {success && <Alert variant="success">Login successful</Alert>}

              <Form onSubmit={handleSubmit}>
                <Row>
                  <img src={wordmark} className="signin-logo"/>
                  <h3 className='auth-title'>Login</h3>
                </Row>
                <Row>
                  {render_form_input('loginEmail', 'Email address', 'email', 'Enter email', email, setEmail)}
                </Row>
                
                <Row>
                  {render_form_input('loginPassword', 'Password', 'password', 'Enter password', password, setPassword)}
                </Row>

                <div className="d-grid mt-2 form-button auth-form-button">
                  <Button variant="primary" type="submit">Login</Button>
                </div>
              </Form>

              <div className='forgot-password'>
                  <Link to="/request_password_reset" className='auth_link'>
                    Forgot your password?
                  </Link>
                </div>

				<div className='forgot-password'>
					Not registered? Sign up
					<Link to="/plans" className='auth_link auth-register-link'>
						here
					</Link>
				</div>

            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default LoginView;

